import ProfileInfoPreview, { ProfileInfoPreviewProps } from './ProfileInfoPreview.component';

export type ProfileInfoPreviewType = ProfileInfoPreviewProps;

export default ProfileInfoPreview;
